// extracted by mini-css-extract-plugin
export var text = "_9l-0";